<template>
  <HomeWrapperDark class="blockchain-wrapper">
    <div class="blockchain-stats-charts">
      <HomeTransactionsChart />
      <HomeUniqueUsersChart />
    </div>
  </HomeWrapperDark>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.blockchain-wrapper {
  padding: 16px 36px;
  margin-bottom: 73px;
  min-width: fit-content;
}

.blockchain-stats-charts {
  gap: 20px;
  display: flex;
  width: 100%;

  @media screen and (max-width: 479px) {
    flex-direction: column;
  }
}
</style>
